import React from 'react';
import { Card } from "../Card";
import { Button, Close } from '../Buttons';

import styled from "styled-components";
import { COLOR_PRIMARY_1, COLOR_GREY_TINT } from '../../vars';
import { Times } from '../Icon';
import { HBox } from '../Box';

const Container = styled.div`
    display:flex;
    align-items:center;

    &:not(.checked){
        opacity:0.5;
    }

    &:hover{
        opacity:1;
    }

`;


const Inner = styled.div`

    ${Container}.checked & {
        background-color: ${COLOR_PRIMARY_1};
        border:3px solid white;
    }
   
   width:18px;
   height:18px;
   border-radius:18px;
   
`;

const Outer = styled.div`

    width:22px;
    height:22px;

   border-radius:18px;    
   border:2px solid #999;
   overflow:hidden;
`

const Label = styled.div`
    margin: 0 6px;
`
export function Radio(props){

    return <Container onClick={props.onClick} className={`radio ${props.checked ? 'checked' : ''}`} >
       <Outer>
           <Inner />
        </Outer>
        <Label>{props.children}</Label>
    </Container>
}